module.exports = __webpack_public_path__ + "img/image_slide1_1.91dd6425.png";